import { Row } from '@tanstack/react-table'

import { Log } from '@/types/logs'

export const filterLogsBy =
    (skipWhileFilter?: (log: Log) => boolean) =>
    (row: Row<Log>, columnId: string, filterValue: string | string[]): boolean => {
        const value = row.original[columnId as keyof Log] as string | string[] | undefined

        if (!value || (Array.isArray(value) && !value.length)) {
            return false
        }

        if (skipWhileFilter?.(row.original)) {
            return false
        }

        const formattedFilterValues = [filterValue].flat().map((item) => item.toLocaleLowerCase())

        if (Array.isArray(value)) {
            return value.some((item) => formattedFilterValues.includes(item.toLocaleLowerCase()))
        }

        return formattedFilterValues.some((item) => item === value.toString().toLocaleLowerCase())
    }
